<template>
    <div class="modal-card">
        <header class="modal-card-head">
            <p class="modal-card-title">Link to MCL</p>
        </header>
        <section class="modal-card-body">
            <loading v-if="loading"></loading>
            <o-tabs v-model="tab" class="hide-step-nav" v-else>
                <o-tab-item value="search">
                    <o-field label="Company name">
                        <o-input v-model="search" icon="search"></o-input>
                    </o-field>
                </o-tab-item>
                <o-tab-item value="results">
                    <div class="columns is-multiline">
                        <div class="mb-4">
                            <o-button icon-left="chevron-left" @click="tab = 'search'">Refine search</o-button>
                        </div>
                        <div class="column is-12 has-text-centered" v-if="options.length == 0">
                            No Results
                            <div class="mt-2">
                                <o-button icon-left="plus" @click="NewCompany">Creates a new MCL company</o-button>
                            </div>
                        </div>
                        <div class="column is-12 columns is-multiline" v-else>
                            <div class="column is-6">
                                <o-field v-for="(opt, i) in options" :key="i">
                                    <o-radio v-model="selection" name="dupe" :native-value="opt.ID">{{ opt.Name }}</o-radio>
                                </o-field>
                            </div>
                            <div class="column is-6 link-company-border" v-if="loadingInfo">
                                <loading></loading>
                            </div>
                            <div class="column is-6 link-company-border" v-if="info != null && !loadingInfo">
                                <div>
                                    {{ info.company?.Name }}
                                </div>
                                <div class="mt-2">
                                    <info-line label="City">{{ info.company?.City }}</info-line>
                                </div>
                            </div>
                        </div>
                    </div>
                </o-tab-item>
            </o-tabs>
        </section>
        <footer class="modal-card-foot is-justify-content-space-between">
            <div>
                <o-button variant="light" @click="Close">Close</o-button>
            </div>
            <div>
                <o-button variant="primary" :disabled="loading" @click="SearchCompanies" v-if="tab == 'search'">Search</o-button>
                <o-button variant="primary" :disabled="loading || loadingInfo || !selection" @click="Link" v-if="tab == 'results'">
                    Link
                </o-button>
            </div>
        </footer>
    </div>
</template>
<script>
    import infoLine from "@/components/webComponents/infoLine.vue";
    import editCompanyModal from "@/components/modals/new-company.vue";
    import { ref, computed, inject, watch, onMounted, getCurrentInstance } from "vue";

    export default {
        components: {
            infoLine
        },
        props: {
            inveniasCompany: {
                type: Object,
                default: () => {
                    return {};
                }
            }
        },
        emits: ["close"],
        setup(props, context) {
            const oruga = inject("oruga");
            const http = inject("$http");
            const success = inject("$success");
            const error = inject("$error");

            const loadingInfo = ref(false);
            const loading = ref(true);
            const isValid = ref(true);
            const options = ref([]);
            const selection = ref();
            const info = ref(null);
            const tab = ref('search');
            const search = ref(props.inveniasCompany.Name);


            const defaultWebsite = computed(() => {
                if (info.value) {
                    const defaultWebsites = info.value.Websites.filter(x => x.IsVisibleAsDefault);
                    if (defaultWebsites.length > 0) {
                        const item = defaultWebsites[0];
                        if (item.ItemValue) return item.ItemValue;
                        else if (item.DefaultValue) return item.DefaultValue;
                        else if (item.FieldName == "LinkedIn") return "https://www.linkedin.com/company/" + info.value.CompanyName;
                        //return defaultWebsites[0];
                        return "";
                    }
                    else return "N/A";
                }
                else return null;
            });

            const totalCandidates = computed(() => {
                if (info.value) {
                    const assignments = info.value.Assignments;
                    const totals = assignments.map(a => a.TotalCandidates || 0);
                    const sum = totals.reduce((n, acc) => acc + n, 0);
                    return sum;
                }
                else return 0;
            });

            const totalAssignments = computed(() => {
                if (info.value) {
                    return info.value.Assignments.length;
                }
                else return 0;
            })

            const SearchCompanies = async () => {
                loading.value = true;
                try {
                    const resp = await http.get("/api/v2/company/search?companyName=" + encodeURIComponent(search.value));
                    options.value = resp.data;
                } catch (err) {
                    console.error(err);
                }

                tab.value = 'results';
                loading.value = false;
            }

            const GetCompanyInfo = async (itemId) => {
                loadingInfo.value = true;

                try {
                    const resp = await http.get("/api/v2/company/" + itemId);
                    info.value = resp.data;
                } catch (err) {
                    console.error(err);
                }

                loadingInfo.value = false;
            }

            const Close = () => {
                context.emit("close");
            };

            const Link = async () => {
                loading.value = true;
                try {
                    const resp = await http.get("/api/v2/company/" + selection.value + "/invenias/" + props.inveniasCompany.ID + "/link");
                    context.emit("close", { linked: true, mclId: selection.value });
                    success("Linked company to Invenias.");
                } catch (err) {
                    console.error(err);
                }
                loading.value = false;
            }

            const NewCompany = async () => {

                loading.value = true;
                try {
                    const resp = await http.get("/api/v2/company/invenias/" + props.inveniasCompany.ID + "/create");
                    context.emit("close", { linked: true, mclId: resp.data.ID });
                    success("New MCL record created");
                } catch (err) {
                    console.error(err);
                    error(err?.response?.data || "This Invenias company does not exist.");
                }
                loading.value = false;

                /*

                oruga.modal.open({
                    parent: getCurrentInstance(),
                    component: editCompanyModal,
                    trapFocus: true,
                    props: {
                        saveAs: "mcl"
                    },
                    events: {
                        saved: async (result) => {
                            if (result) {
                                search.value = result.company.ZI_C_COMPANY_NAME;
                                result.close();
                                await SearchCompanies();
                            }
                        }
                    }
                });
                */
            }

            watch(() => selection.value, (n, o) => {
                if (n != o) {
                    GetCompanyInfo(n);
                }
            });

            onMounted(() => {
                SearchCompanies();
            })

            return {
                loadingInfo,
                loading,
                isValid,
                options,
                selection,
                info,
                tab,
                search,
                defaultWebsite,
                totalCandidates,
                totalAssignments,
                SearchCompanies,
                Close,
                Link,
                NewCompany
            };
        }
    };
</script>
<style>
    .link-company-border {
        border: 1px solid black;
        border-radius: 3px;
    }
</style>
